import React, { Component } from "react";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate, Link } from "react-router-dom";
import store from "@/redux/store";

import * as CustomerConst from "actions/customerConst";
import {FieldHolder} from "@/components/holders/FieldHolder";


export default function ResetPasswordSet({...props}) {
  const onResetEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    const data = new FormData(event.target);
    const value = Object.fromEntries(data.entries());

    props.onResetpasswordSetEvent(value);
    return false;
    };    
    
      return (
        <>


      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            alt="Your Company"
            src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
            className="mx-auto h-10 w-auto"
          />
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Opnieuw wachtwoord instellen
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form onSubmit={onResetEvent} className="space-y-6">
            

            <FieldHolder colspan="12" smcolspan="12" label="Nieuw wachtwoord" id="password" error={props?.state?.error}>                
                  <input
                    id="password"
                    name="password"
                    type="password"
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>

            <FieldHolder colspan="12" smcolspan="12" label="Wachtwoord controle" id="password_confirmation" error={props?.state?.error}>                
                  <input
                    id="password_confirmation"
                    name="password_confirmation"
                    type="password2"
                    data-dashlane-disabled-on-field="true"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
            </FieldHolder>
            
            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Wachtwoord opnieuw instellen
              </button>
            </div>
          </form>

          <p className="mt-10 text-center text-sm text-gray-500">
            <Link className="font-semibold leading-6 text-indigo-600 hover:text-indigo-500" to="/">
              Terug naar inlog pagina
            </Link>
          </p>
        </div>
      </div>




        </>
      );
}
